// @flow
import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { MdAdd } from 'react-icons/lib/md';
import i18n from 'i18n-js';

import User from '../User';
import Card from '../Card';
import * as selectors from '../../reducers';
import * as monitorActions from '../../actions/monitors';
import * as closeableActions from '../../actions/closeable';
import CardHeader from '../CardHeader';
import CardContent /* , { LoadingCardContent } */ from '../CardContent';
import MonitorDataPanel from './MonitorDataPanel';
import CardHeaderRightGroup from '../CardHeaderRightGroup';
import CardHeaderTitleContainer from '../CardHeaderTitleContainer';
import Collapsable from '../Accordion/Collapsable';
import Panel from '../Accordion/Panel';

import styles from './monitorCard.css';
import type { MONITOR_TYPE } from '../../types/monitors';
import OmnisearchLoadingResults from '../OmnisearchLoadingResults';
import type { ROUTE_TYPE } from '../../types/routes';
import { ReduxClickPopover } from '../Closeable';
import RouteSearchPopover from '../RouteSearchPopover';
import Popup from '../Popup';
import ConfirmMonitorChangeRoutePopup from '../ConfirmMonitorChangeRoutePopup';
import RoutesPanelComponent from './RoutesPanel';
import { getUserImage } from '../../utils';


type MonitorCardDummyPropTypes = {
  id: number,
  monitor: MONITOR_TYPE,
  startAddMonitorRoute: Function,
  open: Function,
  monitorRoutes: Array<ROUTE_TYPE>,
  updateMonitor: Function,
};

type MonitorCardDummyStateTypes = {
  selectedRoute?: ROUTE_TYPE,
};

class MonitorCardDummy extends Component<MonitorCardDummyPropTypes, MonitorCardDummyStateTypes> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      monitor,
      open,
      startAddMonitorRoute,
      updateMonitor,
    } = this.props;

    const {
      selectedRoute,
    } = this.state;
    return (
      <Fragment>
        <Popup
          id="confirmMonitorChange"
          theme="main"
          transitionType="slideDown"
          transitionMs={600}
        >
          <ConfirmMonitorChangeRoutePopup
            okAction={startAddMonitorRoute}
            route={selectedRoute}
            monitor={monitor}
          />
        </Popup>
        <Card className={styles.monitorCard} isRound {...this.props}>
          <CardHeader>
            <CardHeaderTitleContainer>
              {
                typeof monitor !== 'undefined'
                  ? (
                    <User
                      firstName={monitor.first_name}
                      lastName={monitor.last_name}
                      userRole="monitor"
                      pictureURL={getUserImage(monitor.profile_picture)}
                      useAsTitle
                    />
                  ) : <OmnisearchLoadingResults />
              }
            </CardHeaderTitleContainer>
            <CardHeaderRightGroup />
          </CardHeader>
          <CardContent clearPaddings>
            <Collapsable accordion>
              <Panel
                title={i18n.t('titles.personalInfo')}
                // badgeCount={8}
                key="1"
              >
                <MonitorDataPanel
                  monitor={monitor}
                  updateMonitor={updateMonitor}
                />

              </Panel>

              <Panel
                key="2"
                title={i18n.t('labels.route', { count: 2 })}
                ActionComponent={
                  () => (
                    <ReduxClickPopover
                      isInline
                      id="qaerwdfsdfsdf"
                      Content={RouteSearchPopover}
                      vertical="middle"
                      horizontal="after"
                      tipPosition="middle"
                      isRound="true"
                      onRouteSelected={(element) => {
                        this.setState({ selectedRoute: element });
                        if (element.monitor) {
                          open('confirmMonitorChange');
                        } else {
                          startAddMonitorRoute(monitor.id, element.id);
                        }
                      }}
                    >
                      <button type="actionButton">
                        <MdAdd size={30} />
                      </button>
                    </ReduxClickPopover>
                  )
                }

              >
                { monitor && <RoutesPanelComponent monitor={monitor} /> }
              </Panel>

            </Collapsable>
          </CardContent>
        </Card>
      </Fragment>
    );
  }
}
const MonitorCard = connect(
  (state, props) => {
    const { id } = props;
    const monitor = selectors.getMonitor(state, id);

    return {
      monitor,
    };
  },
  dispatch => ({
    updateMonitor(monitor) {
      dispatch(monitorActions.updateMonitorStart({ ...monitor }));
    },
    open: (id: string) => dispatch(closeableActions.open(id)),
    startAddMonitorRoute: (
      idMonitor: number,
      idRoute: number,
    ) => dispatch(monitorActions.addMonitorRouteStarted(idMonitor, idRoute)),
  }),
)(MonitorCardDummy);


export default MonitorCard;



// WEBPACK FOOTER //
// ./src/scripts/components/MonitorCard/index.jsx